import { Component, OnInit } from '@angular/core';
import { NotifyService } from 'src/app/services/notify.service';

@Component({
  selector: 'app-bell',
  templateUrl: './bell.component.html',
  styleUrls: ['./bell.component.less'],
})
export class BellComponent implements OnInit {
  alertCounts;

  constructor(private notifyService: NotifyService) {}

  ngOnInit(): void {
    this.alertCounts =
      this.notifyService.msgCount +
      this.notifyService.activitiesCount +
      this.notifyService.servicesCount;

    this.notifyService.activitiesCountChanged.subscribe(() => {
      this.alertCounts =
        this.notifyService.msgCount +
        this.notifyService.activitiesCount +
        this.notifyService.servicesCount;
    });

    this.notifyService.msgCountChanged.subscribe(() => {
      this.alertCounts =
        this.notifyService.msgCount +
        this.notifyService.activitiesCount +
        this.notifyService.servicesCount;
    });

    this.notifyService.servicesCountChanged.subscribe(() => {
      this.alertCounts =
        this.notifyService.msgCount +
        this.notifyService.activitiesCount +
        this.notifyService.servicesCount;
    });
  }
}
